module.exports = __webpack_public_path__ + "static/media/bid-letter-header.e0fa679b.png";


//////////////////
// WEBPACK FOOTER
// ./src/branding/complex-solutions/bid-letter-header.png
// module id = 3623
// module chunks = 0